<button hb-button class="hb-float-right filterknapp" [variant]="'PROMINENT'" aria-label="Vis filter" (click)="visFilter = true">Vis filter</button>
<div class="filter" [ngClass]="{ 'filter--utvidet': visFilter }">
  <div class="hb-panel hb-panel--hvit">
    <aside>
      <h2 class="hb-h2">
        Filter
        <button
          hb-button
          class="hb-float-right filterknapp"
          [variant]="'SUBTLE'"
          aria-label="Lukk filter"
          [iconId]="'remove'"
          [hideText]="true"
          (click)="visFilter = !visFilter"
        ></button>
      </h2>

      <p>Når du ser på tidligere års data vil disse vises etter dagens gjeldende kommunestruktur</p>

      <div class="hb-panel hb-panel--info">
        <h3 class="hb-h3 hb-text--base hb-mb--md">
          @if (objectKeys(selected).length > 0) {
            <hb-icon iconId="filter-1"></hb-icon>
          }
          @if (objectKeys(selected).length === 0) {
            <hb-icon iconId="hb-filter-off"></hb-icon>
          }
          Valgte filter
        </h3>

        @for (filter of objectKeys(selected); track filter) {
          <div class="hb-mb--md">
            <div class="hb-text--sm">
              <strong>{{ filter }}: </strong>
            </div>
            <span class="hb-text--sm">{{ selected[filter].join(", ") }}</span>
          </div>
        }
        <button hb-button (click)="removeFilter()" [variant]="'PROMINENT'">Nullstill</button>
      </div>

      @for (filter of filterListe[seksjon]; track filter) {
        <stat-qlik-list
          #qlikfilter
          [id]="filter.id"
          [subId]="filter.subId ? filter.subId : null"
          [tittel]="filter.tittel"
          [default]="filter.default ? filter.default : []"
          [hideIrrelevant]="filter.reduce"
          (selected)="selection($event)"
          [multiselect]="filter.multiselect"
          [qlikfield]="filter.qlikfield ? filter.qlikfield : null"
          [sorteringOrientation]="filter.sorteringOrientation ? filter.sorteringOrientation : null"
          [sorteringField]="filter.sorteringField ? filter.sorteringField : null"
          [qlikOptions]="filter.qlikOptions ? filter.qlikOptions : null"
          [ngClass]="filter.komprimertVisning ? 'visning-komprimert' : ''"
          [type]="filter.type ?? 'checkbox'"
        >
        </stat-qlik-list>
      }
    </aside>
  </div>
</div>

@if (visFilter) {
  <div class="overlay"></div>
}
